document.addEventListener('click', function (e) {
  var thumb = e.target.closest('[data-thumb]');
  if (thumb) {
    var root = thumb.closest('[data-gallery]');
    root.querySelector('[data-gallery-main]').src = thumb.dataset.full;
    root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }
  var chip = e.target.closest('[data-slide]');
  if (chip) {
    var wrap = chip.closest('[data-showcase]');
    var i = chip.dataset.slide;
    wrap.querySelectorAll('[data-slide]').forEach(function (c) { c.classList.toggle('is-active', c.dataset.slide === i); });
    wrap.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== i; });
  }
});
document.querySelectorAll('[data-ba]').forEach(function (el) {
  var input = el.querySelector('input');
  var after = el.querySelector('.after');
  var handle = el.querySelector('.handle');
  function set(v) { after.style.clipPath = 'inset(0 0 0 ' + v + '%)'; handle.style.left = v + '%'; }
  input.addEventListener('input', function () { set(input.value); });
  set(input.value);
});

/* ---- featured product / PDP carousel ---- */
(function () {
  function show(root, idx) {
    var slides = root.querySelectorAll('[data-pdp-slide]');
    if (!slides.length) return;
    idx = (idx + slides.length) % slides.length;
    slides.forEach(function (s) { s.hidden = Number(s.dataset.index) !== idx; });
    root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', Number(t.dataset.index) === idx);
    });
    var counter = root.querySelector('[data-pdp-counter]');
    if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
    root.dataset.pdpIndex = idx;
  }
  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-pdp-carousel]');
    if (!root) return;
    var current = Number(root.dataset.pdpIndex || 0);
    if (e.target.closest('[data-pdp-prev]')) show(root, current - 1);
    else if (e.target.closest('[data-pdp-next]')) show(root, current + 1);
    else {
      var thumb = e.target.closest('[data-pdp-thumb]');
      if (thumb) show(root, Number(thumb.dataset.index));
    }
  });
})();

/* ---- quantity steppers ---- */
document.addEventListener('click', function (e) {
  var dec = e.target.closest('[data-qty-decrease]');
  var inc = e.target.closest('[data-qty-increase]');
  if (!dec && !inc) return;
  var field = (dec || inc).closest('.qty-stepper');
  var input = field && field.querySelector('[data-qty-input]');
  if (!input) return;
  var v = parseInt(input.value, 10) || 1;
  input.value = Math.max(1, inc ? v + 1 : v - 1);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* ---- variant selection ---- */
document.querySelectorAll('[data-product-form-wrapper]').forEach(function (wrapper) {
  var raw = wrapper.dataset.productJson;
  if (!raw) return;
  var product;
  try { product = JSON.parse(raw); } catch (err) { return; }
  var form = wrapper.querySelector('[data-product-form]');
  if (!form) return;
  function money(cents) {
    return (window.Shopify && Shopify.currency ? '' : '') + '$' + (cents / 100).toFixed(2);
  }
  function update() {
    var chosen = [];
    wrapper.querySelectorAll('.option-selector').forEach(function (sel) {
      var checked = sel.querySelector('[data-option-input]:checked');
      chosen[Number(sel.dataset.optionIndex)] = checked ? checked.value : null;
    });
    var variant = product.variants.filter(function (v) {
      return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
    })[0];
    if (!variant) return;
    var idInput = wrapper.querySelector('[data-variant-id]');
    if (idInput) idInput.value = variant.id;
    var price = wrapper.querySelector('[data-price]');
    if (price) price.textContent = money(variant.price);
    var compare = wrapper.querySelector('[data-compare-price]');
    if (compare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.textContent = money(variant.compare_at_price);
        compare.hidden = false;
      } else { compare.hidden = true; }
    }
    var btn = wrapper.querySelector('[data-add-to-cart]');
    var label = wrapper.querySelector('[data-add-to-cart-label]');
    if (btn) btn.disabled = !variant.available;
    if (label) label.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    if (history.replaceState && wrapper.closest('.template-product, [data-main-product]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  }
  wrapper.addEventListener('change', function (e) {
    if (e.target.matches('[data-option-input]')) update();
  });
});

/* ---- cart drawer + AJAX cart ---- */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var list = drawer.querySelector('[data-cart-drawer-items]');
    var tpl = document.getElementById('cart-drawer-item-template');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var countEl = drawer.querySelector('[data-cart-drawer-count]');
    if (!list || !tpl) return;
    list.innerHTML = '';
    if (!cart.items.length) {
      if (countEl) countEl.textContent = 'Your cart is empty';
      if (footer) footer.hidden = true;
      return;
    }
    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in your cart';
    cart.items.forEach(function (item) {
      var node = tpl.content.cloneNode(true);
      var row = node.querySelector('.cart-drawer-item');
      row.dataset.lineKey = item.key;
      var img = node.querySelector('.cdi-image img');
      img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      img.alt = item.product_title;
      node.querySelector('.cdi-image').href = item.url;
      var title = node.querySelector('.cdi-title');
      title.textContent = item.product_title;
      title.href = item.url;
      node.querySelector('.cdi-variant').textContent =
        item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      node.querySelector('.cdi-price').textContent = formatMoney(item.final_line_price);
      node.querySelector('[data-cart-qty-value]').textContent = item.quantity;
      list.appendChild(node);
    });
    drawer.querySelector('[data-cart-drawer-subtotal]').textContent = formatMoney(cart.total_price);
    if (footer) footer.hidden = false;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      if (document.querySelector('[data-cart-page]')) window.location.reload();
      return cart;
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () { openDrawer(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); fetchCart().then(openDrawer); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    var row = e.target.closest('[data-line-key]');
    if (!row) return;
    var key = row.dataset.lineKey;
    var qtyEl = row.querySelector('[data-cart-qty-value]');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
    if (e.target.closest('[data-cart-qty-increase]')) changeLine(key, qty + 1);
    else if (e.target.closest('[data-cart-qty-decrease]')) changeLine(key, qty - 1);
    else if (e.target.closest('[data-cart-remove]')) changeLine(key, 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-qty]');
    if (!input) return;
    var row = input.closest('[data-line-key]');
    if (row) changeLine(row.dataset.lineKey, parseInt(input.value, 10) || 0);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  document.addEventListener('DOMContentLoaded', function () { fetchCart(); });
})();
